import "core-js/modules/es.array.includes";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.starts-with";
import axios from 'axios'; // eslint-disable-next-line import/no-cycle

import router from '@/router';
import { Message } from 'hui'; // eslint-disable-next-line import/no-cycle

import store from '@/store/index';
import Token from '@/config/token';
import { responseCode, statusCode } from './httpCode';
var service = axios.create({
  baseURL: '/',
  headers: {
    get: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
      'X-Requested-With': 'XMLHttpRequest'
    },
    post: {
      'Content-Type': 'application/json;charset=utf-8',
      'X-Requested-With': 'XMLHttpRequest'
    }
  },
  timeout: 30000,
  validateStatus: function validateStatus(val) {
    if (val >= 200 && val < 400 || val === 403) {
      return true;
    }

    if (statusCode[val]) {
      Message.error("".concat(statusCode[val], "\uFF0C\u8BF7\u91CD\u8BD5\uFF01"));
    } else {
      Message.error('未知错误，请重试！');
    }

    return false;
  },
  transformResponse: [function (data) {
    if (typeof data === 'string' && data.startsWith('{')) {
      data = JSON.parse(data);
    }

    return data;
  }]
}); // 请求拦截器

service.interceptors.request.use(function (config) {
  if (!config.data) {
    config.data = {};
  }

  if (config.isImport) {
    config.headers['Content-Type'] = 'multipart/form-data';
  }

  if (store.getters.token) {
    // 让每个请求携带token信息
    config.headers.Authorization = Token.getToken();
    config.headers.cmAuthorization = Token.getCMToken();
  }

  return config;
}, function (error) {
  console.log(error);
  Message.error('请求出错，请重试');
  return Promise.reject(error);
}); // 响应拦截器

service.interceptors.response.use(function (res) {
  if (res.config.responseType === 'blob' && res.status === 200) {
    return Promise.resolve(res);
  }

  if (responseCode.includes(res.data.code)) {
    return Promise.resolve(res.data);
  }

  if (res.data.code === '401') {
    // token失效的具体原因
    store.dispatch('FedLogOut').then(function () {
      router.push({
        path: '/login'
      }); // Message.error(res.data.msg);
    });
    return Promise.reject(res);
  } // 需要弹窗提示的业务


  if (res.data.code !== '200' || res.data.code !== '0') {
    // 特殊业务处理，开始会议接口
    if (res.data.code !== '504') {
      Message.error(res.data.msg);
    }

    return Promise.reject(res.data);
  }

  return new Promise(function () {});
}, // 对请求错误做些什么
// TODO 根据后台规则
// eslint-disable-next-line arrow-body-style
function (error) {
  console.log(error);
  Message.error('请求出错，请重试');
  return Promise.reject(error);
});
export default service;